export default __webpack_public_path__ + "static/media/F_wdt_c_cap_3.0f5cd393.mp3";